<template>
    <a href="/compare"
       title="Перейти в сравнение"
       class="menu-icon-item menu-icon-item_fav"
       :class="this.isActive() ? '_active' : ''"
    >
      <span class="menu-icon-item__wrap">
        <span class="menu-icon-item__icon-wrap">
          <span class="menu-icon-item__icon">
            <CompareIcon/>
            <span class="menu-icon-item__count">
              {{ count }}
            </span>
          </span>
        </span>
        <span class="menu-icon-item__title">
          Сравнение
        </span>
      </span>
    </a>
</template>

<script>
    import CompareIcon from "../icons/CompareIcon";
    import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
    import CartIcon from "../icons/CartIcon.vue";
    export default {
        name: "TheCompareWidget",
        components: {
          CartIcon,
            CompareIcon
        },
        methods: {
            ...mapActions({
                'loadCheckout': 'compare/loadCheckout'
            }),
            isActive() {
              return window.location.pathname === '/compare';
            }
        },
        computed: {
            ...mapGetters('compare', {
                'count': 'count'
            })
        },
        mounted() {
            this.loadCheckout();
        }
    }
</script>

<style lang="scss">

</style>